import React from "react";

export default function Footer() {
  return (
    <footer className="typora-footer">
      <div className="footer-heading">Social Media Presence</div>
      <ul className="ha-footer-icons">
        <li className="ha-footer-icons social-icon">
          <a className="link" href="https://github.com/mdarif6">
            <i className="fab fa-github"></i>
          </a>
        </li>
        <li className="ha-footer-icons social-icon">
          <a className="link" href="https://www.linkedin.com/in/mdarifdev/">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </li>
        <li className="ha-footer-icons social-icon">
          <a className="link" href="https://twitter.com/mdarifdev">
            <i className="fab fa-twitter"></i>
          </a>
        </li>
      </ul>
      <div>
        <small>&copy; Md Arif 2022 </small>
      </div>
    </footer>
  );
}
